// frontend/src/components/ProfileDialog.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const ProfileDialog = ({
  open,
  onClose,
  onSubmit,
  loading,
  formData,
  setFormData,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("auth.profile.addProfile")}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          margin="normal"
          label={t("auth.profile.profileName")}
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          required
          error={!formData.name}
          helperText={!formData.name && t("auth.profile.nameRequired")}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("common.actions.cancel")}
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={loading || !formData.name}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            t("userForm.actions.create")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProfileDialog;
